@use "../../style/mixins" as *;
@use "../../style/variables" as *;

.background {
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100dvh;
  z-index: 100;
  background-color: $black-transparent;

  .container {
    width: 90%;
    position: relative;
    display: flex;
    z-index: 2;
    background-color: $white;
    border-radius: 10px;

    @include tablet {
      width: 100%;
    }

    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .img {
        width: 100%;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }

      .gmcText {
        color: $grey-dark;
        font-weight: 500;
        padding: 1.5rem;
        text-align: center;
        line-height: 1.3;
        margin: .25rem;

        @include tablet {
          width: 75%;
        }
      }

      .buttonWrapper {
        padding: .5rem 1.5rem 2.5rem 1.5rem;
        width: 100%;
        display: flex;
        justify-content: center;

        button {
          width: 75%;
          height: auto;
          font-size: .8125rem;

          @include tablet {
            width: 140px;
            height: auto;
            font-size: .8125rem;
          }
        }
      }
    }

    .srOnly {
      display: none;
    }

    .closeBtn {
      position: absolute;
      top: 1rem;
      right: 1rem;
      background: none;
      border: none;
      padding: 0;
      cursor: pointer ;

      .closeIcon {
        color: $white;

        @include tablet {
          height: 2rem;
        }
      }
    }

    @include tablet {
      max-width: 750px;
      width: 750px;
    }

    @media screen and (max-width: 900px)  {
      .img {
        width: 90vw;
      }

      .closeIcon {
        height: 1.5rem;
      }
    }
    @media screen and (max-width: 300px)  {
      .closeIcon {
        height: 1rem;
      }
    }
  }
}
